import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salary-forms-alternate',
    templateUrl: './salary-forms-alternate.component.html',
    styleUrl: './salary-forms-alternate.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SalaryFormsAlternateComponent {
  constructor(
  ) {
  }
}
